/* Stepper množství na produktové kartě (vzor aktin.cz).
   Obaluje quick-add CTA i stepper; atribut [in-cart] přepíná mezi nimi.
   Server vykreslí výchozí stav přes `cart | item_count_for_variant`,
   tady se řeší +/- přes Cart API, refresh bubliny košíku a synchronizace
   přes pub/sub událost cartUpdate (přidání přes CTA přepne kartu na stepper
   bez reloadu; změny z košíku/draweru se propíšou zpět na kartu).
   Jen pro produkty s jedinou variantou — vícevariantní mají vždy CTA s modalem. */

if (!customElements.get('product-card-cart')) {
  customElements.define(
    'product-card-cart',
    class ProductCardCart extends HTMLElement {
      connectedCallback() {
        this.stepper = this.querySelector('.product-card__stepper');
        if (!this.stepper) return;

        this.variantId = Number(this.dataset.variantId);
        this.qtyButton = this.querySelector('[data-stepper-qty]');
        this.querySelector('[data-stepper-minus]').addEventListener('click', () => this.change(-1));
        this.querySelector('[data-stepper-plus]').addEventListener('click', () => this.change(1));
        // Na mobilu je sbalený stepper jen kostička s počtem — tap rozbalí ovládání
        this.qtyButton.addEventListener('click', () => this.toggleAttribute('expanded'));
        this.onDocumentClick = (event) => {
          if (!this.contains(event.target)) this.removeAttribute('expanded');
        };
        document.addEventListener('click', this.onDocumentClick);

        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source === 'product-card-cart' && event.element === this) return;
          this.syncFromCart(event.cartData);
        });
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
        if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
      }

      get quantity() {
        return parseInt(this.qtyButton.textContent, 10) || 0;
      }

      setQuantity(quantity) {
        this.qtyButton.textContent = quantity;
        this.toggleAttribute('in-cart', quantity > 0);
        if (quantity === 0) this.removeAttribute('expanded');
      }

      async syncFromCart(cartData) {
        try {
          // Odpověď /cart/add.js (CTA) nenese celý košík — došteme si ho
          let items = cartData && cartData.items;
          if (!items) {
            const response = await fetch(`${routes.cart_url}.js`);
            items = (await response.json()).items;
          }
          const quantity = items
            .filter((item) => item.variant_id === this.variantId)
            .reduce((sum, item) => sum + item.quantity, 0);
          this.setQuantity(quantity);
        } catch {
          /* síťová chyba — ponecháme poslední známý stav */
        }
      }

      async change(delta) {
        const newQuantity = Math.max(0, this.quantity + delta);
        this.stepper.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(routes.cart_update_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: { [this.variantId]: newQuantity }, sections: 'cart-icon-bubble' }),
          });
          const cart = await response.json();
          if (cart.status) throw new Error(cart.message);

          const bubble = document.getElementById('cart-icon-bubble');
          if (bubble && cart.sections && cart.sections['cart-icon-bubble']) {
            const parsed = new DOMParser().parseFromString(cart.sections['cart-icon-bubble'], 'text/html');
            bubble.innerHTML = parsed.querySelector('.shopify-section').innerHTML;
          }

          // Skutečné množství z odpovědi (sklad může požadavek snížit)
          this.syncFromCart(cart);
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-card-cart',
            element: this,
            cartData: cart,
            variantId: this.variantId,
          });
        } catch (error) {
          console.error(error);
        } finally {
          this.stepper.removeAttribute('aria-busy');
        }
      }
    }
  );
}
